<template>

<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title>Remove one, some or all LOS prices</v-card-title>
    <v-row no-gutters>
      <v-col cols="4" class="px-2">
        <v-menu
          v-model="hspt.hsfp_van_datMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          readonly 
          offset-y
          min-width="290px"
        >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="hspt.hsfp_van_dat"
            label="From arrival date"
            v-on="on"
            dense
          ></v-text-field>
        </template>
        <v-date-picker v-model="hspt.hsfp_van_dat" :first-day-of-week="1" @input="hspt.hsfp_van_datMenu = false"></v-date-picker>
        </v-menu>  
      </v-col>
      <v-col cols="4" class="px-2">
        <v-menu
          v-model="hspt.hsfp_tm_datMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          readonly 
          offset-y
          min-width="290px"
        >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="hspt.hsfp_tm_dat"
            label="Until arrival date"
            v-on="on"
            dense
          ></v-text-field>
        </template>
        <v-date-picker v-model="hspt.hsfp_tm_dat" :first-day-of-week="1" @input="hspt.hsfp_tm_datMenu = false"></v-date-picker>
        </v-menu>  
      </v-col>  
    </v-row>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="rmHsfp()">Remove prices</v-btn> 
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

import {bus} from "../../../../main";

export default {
  data() { 
    return {
      dialog: false,
      hspt_encrid: null,
      hspt: {},
    }
  },
  methods: {
    open(hspt_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hspt/hsfp/getHsptToRmHsfp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHsptToRmHsfp"
          },
          getHsptToRmHsfp: {
            hspt_encrid: hspt_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hspt = res.data.getHsptToRmHsfp;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmHsfp() { 
      this.$axios
        .post("ares/json/ares/huis/hspt/hsfp/rmHsfp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmHsfp"
          },
          rmHsfp: {
            hspt_encrid: this.hspt.hspt_encrid,
            hsfp_van_dat: this.hspt.hsfp_van_dat,
            hsfp_tm_dat: this.hspt.hsfp_tm_dat
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
            if (res.data.rmHsfp.color == "success") {
                //this.$router.reload('/huis/hspt/hsfp/updHsfp/' + res.data.rmHsfp.hspt_encrid); 
                bus.$emit("closeDialog", "reload"); 
             }
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmHsfp.text,
              color: res.data.rmHsfp.color
            }); 
            this.dialog = false;
          }
        })
    }
  }
}
</script>

